import { crudPage } from '../ui/crud.js';
import { el, clear, formatarTitulo, formatarNome, fmtData, fmtDataHora } from '../lib/dom.js';
import { supabase } from '../config/supabaseClient.js';
import { toast } from '../lib/toast.js';
import { abrirModal } from '../ui/modal.js';
import { buscaSelect } from '../ui/buscaSelect.js';
import { loader } from '../ui/loader.js';
import { renderTabela } from '../ui/table.js';
import { assinarTabela, pollPeriodico } from '../lib/realtime.js';
import { abrirAprovacao } from '../ui/aprovarComSimilar.js';
import { buscarTodos } from '../lib/db.js';
import { listarMotivosPendentes, listarEmpresasPendentes } from '../domain/visitaListas.js';

const OPCOES_STATUS = [
  { value: 'ATIVO', label: 'Ativo' },
  { value: 'INATIVO', label: 'Inativo' },
];

function badgeVis(status) {
  const m = { ATIVO: ['badge--ok', 'Ativo'], INATIVO: ['badge--off', 'Inativo'], PENDENTE: ['badge--alerta', 'Pendente'] };
  const [cls, txt] = m[status] || ['badge--off', status || ''];
  return el('span', { class: `badge ${cls}`, text: txt });
}

function fazPaginaLista({ tabela, rpcUsos, chaveUso, fundirRpc, descartarRpc = null, titulo, singular, rotuloItem, subtitulo, listarPend }) {
  async function setStatus(l, novo, api, msg) {
    const { error } = await supabase.from(tabela).update({ status: novo }).eq('id', l.id);
    if (error) { toast('Erro: ' + error.message, 'erro'); return; }
    toast(msg, 'sucesso'); api.recarregar?.();
  }
  function confirmarRemover(l, api, { titulo: tt, texto, msgOk, msgErro }) {
    abrirModal({
      titulo: tt,
      corpo: [el('p', { class: 'view__sub', style: 'margin-top:0', text: texto })],
      acoes: [
        { rotulo: 'Cancelar', classe: 'btn' },
        { rotulo: tt.split(' ')[0], classe: 'btn btn--perigo', onClick: async () => {
          const { error } = await supabase.from(tabela).delete().eq('id', l.id);
          if (error) { toast(msgErro + error.message, 'erro'); return false; }
          toast(msgOk, 'sucesso'); api.recarregar?.(); return true;
        } },
      ],
    });
  }
  async function fundir(l, aoFeito) {
    const { data } = await supabase.from(tabela).select('id, nome, status').neq('id', l.id).in('status', ['ATIVO', 'INATIVO']).order('nome');
    const opcoes = (data || []).map((r) => ({ value: r.id, label: r.status === 'ATIVO' ? r.nome : `${r.nome} (inativo)` }));
    if (!opcoes.length) { toast('Não há cadastro para fundir.', 'info'); return; }
    const picker = buscaSelect({ opcoes, limite: 1000 });
    abrirModal({
      titulo: `Fundir ${singular}`,
      corpo: [
        el('p', { class: 'view__sub', style: 'margin-top:0', text: `As visitas de "${l.nome}" (se houver) passam para o cadastro escolhido, e "${l.nome}" é removido. Use para juntar duplicatas (ex.: grafia diferente).` }),
        el('div', { class: 'campo' }, [el('label', { text: 'Manter (cadastro que vai ficar):' }), picker.elemento]),
      ],
      acoes: [
        { rotulo: 'Cancelar', classe: 'btn' },
        { rotulo: 'Fundir', classe: 'btn btn--primario', onClick: async () => {
          const alvo = picker.getValue();
          if (!alvo) { toast('Escolha o cadastro que vai ficar.', 'erro'); return false; }
          const { data: n, error } = await supabase.rpc(fundirRpc, { p_de: l.id, p_para: alvo });
          if (error) { toast('Não foi possível fundir: ' + error.message, 'erro'); return false; }
          toast(n > 0 ? `Fundido. ${n} visita(s) movida(s).` : 'Fundido. (Nenhuma visita estava vinculada ainda.)', 'sucesso'); aoFeito?.(); return true;
        } },
      ],
    });
  }

  // Quantas visitas usam o item (mesma RPC da coluna "Usos"). null = RPC ausente/erro.
  async function contarUsos(id) {
    try {
      const { data, error } = await supabase.rpc(rpcUsos);
      if (error) return null;
      const achado = (data || []).find((x) => String(x[chaveUso]) === String(id));
      return achado ? Number(achado.total) : 0;
    } catch { return null; }
  }

  // Descartar nome NAO IDENTIFICADO ja usado em visitas (sugestoes do Jorge, 14/08): nao da para Fundir (ninguem sabe
  // qual e a certa) nem apagar direto (a FK das visitas barra). Quem descarta ESCOLHE o destino das visitas; nenhuma
  // opcao vem marcada (decisao de quem conhece o caso, nao do sistema). Requer a migracao 0075.
  // "So esconder" nao e oferecido a PENDENTE (Recusar): la viraria uma recusa que o relatorio de producao conta como
  // aprovacao (me_aprovados = status <> PENDENTE, 0072). Para item ja cadastrado e o Inativar de sempre.
  function descartar(l, aoFeito, { permitirEsconder = true, acao = 'Descartar' } = {}) {
    const n = l.usos || 0;
    const feito = acao === 'Recusar' ? 'Recusado' : 'Descartado';
    const grupo = `descartar-${l.id}`;
    const opcoesDesc = [
      { v: 'limpar', t: 'Apagar o nome dessas visitas', d: 'As visitas continuam registradas, mas ficam sem empresa. O nome some da lista, do balcão, da sugestão de visitante recorrente e dos relatórios (conta como "não informado"). Não dá para desfazer.' },
      { v: 'manter', t: 'Manter o texto digitado nas visitas', d: 'O nome sai da lista de empresas e não é mais oferecido para escolher. O texto continua gravado nas visitas: aparece no relatório de empresas e na sugestão de visitante recorrente (só como texto, sem preencher o campo). Não dá para desfazer.' },
    ];
    if (permitirEsconder) opcoesDesc.push({ v: 'esconder', t: 'Não apagar nada, só esconder', d: 'O nome fica na lista como Inativo e não é mais oferecido para escolher. Mas o visitante recorrente cuja última visita usou este nome ainda vem com ele preenchido. Visitas e relatórios não mudam. Dá para reativar depois.' });
    const radios = opcoesDesc.map((o) => {
      const r = el('input', { type: 'radio', name: grupo, value: o.v });
      return { o, r, linha: el('label', { class: 'cfg-item' }, [r, el('div', {}, [el('div', { class: 'cfg-item__tit', text: o.t }), el('small', { class: 'campo__dica', text: o.d })])]) };
    });
    abrirModal({
      titulo: `${acao} "${l.nome}"`,
      corpo: [
        el('p', { class: 'view__sub', style: 'margin-top:0', text: `"${l.nome}" já foi usado em ${n} visita(s), por isso não pode ser simplesmente apagado. Se você souber qual é a ${singular} certa, feche e use "Fundir": as visitas passam para ela.` }),
        el('div', { class: 'cfg-grupo-lbl', text: 'O que fazer com essas visitas?' }),
        ...radios.map((x) => x.linha),
      ],
      acoes: [
        { rotulo: 'Cancelar', classe: 'btn' },
        { rotulo: acao, classe: 'btn btn--perigo', onClick: async () => {
          const esc = radios.find((x) => x.r.checked)?.o.v;
          if (!esc) { toast('Escolha o que fazer com as visitas.', 'erro'); return false; }
          if (esc === 'esconder') {
            const { data, error } = await supabase.from(tabela).update({ status: 'INATIVO' }).eq('id', l.id).select('id');
            if (error) { toast('Erro: ' + error.message, 'erro'); return false; }
            if (!data || !data.length) { toast('Não foi possível esconder: o item já foi removido ou você não tem permissão para alterar.', 'erro'); return false; }
            toast(`"${l.nome}" escondido (Inativo).`, 'sucesso'); aoFeito?.(); return true;
          }
          const { data: m, error } = await supabase.rpc(descartarRpc, { p_id: l.id, p_limpar_texto: esc === 'limpar' });
          if (error) {
            const falta = /could not find the function|PGRST202|does not exist/i.test(`${error.code || ''} ${error.message || ''}`);
            toast(falta ? 'Falta atualizar o banco (migração 0075). Avise o gestor do sistema.' : `Não foi possível ${acao.toLowerCase()}: ` + error.message, 'erro');
            return false;
          }
          toast(esc === 'limpar' ? `${feito}. ${m} visita(s) ficaram sem empresa.` : `${feito}. ${m} visita(s) mantêm o texto digitado.`, 'sucesso');
          aoFeito?.(); return true;
        } },
      ],
    });
  }
  // Aba "Cadastrados": so itens ATIVO/INATIVO (pendentes ficam na outra aba).
  const crud = crudPage({
    titulo, singular, subtitulo, semCabecalho: true,
    tabela, ordenarPor: 'nome', asc: true,
    filtro: (q) => q.in('status', ['ATIVO', 'INATIVO']),
    colunas: [
      { chave: 'nome', rotulo: rotuloItem, truncar: true, dica: `Nome padronizado do ${singular} (grafia única).` },
      { chave: 'usos', rotulo: 'Usos', largura: '90px', alinhar: 'centro', dica: 'Quantas visitas já usaram este item. Só dá para excluir quando é 0.', render: (l) => (l.usos == null ? '—' : String(l.usos)) },
      { chave: 'status', rotulo: 'Status', largura: '120px', dica: 'Ativo = disponível no balcão; Inativo = oculto.', render: (l) => badgeVis(l.status) },
      { chave: 'aprovado_em', rotulo: 'Aprovado em', largura: '130px', alinhar: 'centro', dica: 'Data em que a sugestão pendente foi aprovada. Em branco para itens cadastrados direto pela gestão (que nunca passaram por aprovação) ou aprovados antes desta atualização.', render: (l) => (l.aprovado_em ? fmtData(l.aprovado_em) : '—') },
    ],
    buscarEm: ['nome'],
    enriquecer: async (linhas) => {
      let mapa = null;
      try {
        const { data, error } = await supabase.rpc(rpcUsos);
        if (!error) { mapa = {}; (data || []).forEach((x) => { mapa[x[chaveUso]] = Number(x.total); }); }
      } catch { /* RPC ausente (0054 nao rodada) */ }
      linhas.forEach((l) => { l.usos = mapa ? (mapa[l.id] || 0) : null; });
    },
    acoesLinha: (l, api) => {
      const out = [];
      const ativo = l.status === 'ATIVO';
      out.push(el('button', { class: 'btn', title: ativo ? 'Inativar' : 'Reativar', 'aria-label': ativo ? 'Inativar' : 'Reativar', onClick: () => setStatus(l, ativo ? 'INATIVO' : 'ATIVO', api, ativo ? 'Inativado.' : 'Reativado.') }, [el('i', { class: ativo ? 'ph ph-prohibit' : 'ph ph-arrow-counter-clockwise' })]));
      out.push(el('button', { class: 'btn', title: 'Fundir com outro (juntar duplicata)', 'aria-label': 'Fundir', onClick: () => fundir(l, () => api.recarregar?.()) }, [el('i', { class: 'ph ph-git-merge' })]));
      if (l.usos === 0) out.push(el('button', { class: 'btn btn--perigo', title: 'Excluir (sem uso)', 'aria-label': 'Excluir', onClick: () => confirmarRemover(l, api, { titulo: `Excluir ${singular}`, texto: `Excluir "${l.nome}"? Nunca foi usado em visitas. Esta ação não pode ser desfeita.`, msgOk: 'Excluído.', msgErro: 'Não foi possível excluir: ' }) }, [el('i', { class: 'ph ph-trash' })]));
      else if (descartarRpc && l.usos > 0) out.push(el('button', { class: 'btn btn--perigo', title: `Descartar (nome já usado em ${l.usos} visita(s); você escolhe o que acontece com elas)`, 'aria-label': 'Descartar', onClick: () => descartar(l, () => api.recarregar?.()) }, [el('i', { class: 'ph ph-trash' })]));
      return out;
    },
    campos: [
      { chave: 'nome', rotulo: rotuloItem, obrigatorio: true, normalizar: formatarTitulo },
      { chave: 'status', rotulo: 'Status', tipo: 'select', opcoes: OPCOES_STATUS, padrao: 'ATIVO' },
    ],
  });

  return {
    async render(container) {
      container.innerHTML = '';
      container.append(
        el('h1', { class: 'view__titulo', text: titulo }),
        el('p', { class: 'view__sub', text: subtitulo }),
      );

      const badge = el('span', { class: 'aba__contador', text: '…' });
      const btnCad = el('button', { class: 'aba aba--ativa', onClick: () => trocar('cad') }, 'Cadastrados');
      const btnPend = el('button', { class: 'aba', onClick: () => trocar('pend') }, [el('span', { text: 'Pendentes ' }), badge]);
      const divCad = el('div');
      const divPend = el('div', { style: 'display:none' });
      container.append(el('div', { class: 'abas' }, [btnCad, btnPend]), divCad, divPend);

      crud.render(divCad);

      let pendFeito = false;
      function trocar(a) {
        btnCad.classList.toggle('aba--ativa', a === 'cad');
        btnPend.classList.toggle('aba--ativa', a === 'pend');
        divCad.style.display = a === 'cad' ? '' : 'none';
        divPend.style.display = a === 'pend' ? '' : 'none';
        if (a === 'pend' && !pendFeito) { pendFeito = true; desenharPend(); }
      }

      let recusando = false; // trava sincrona: o Recusar espera o banco (contarUsos) antes de abrir o modal; sem ela, clique duplo abria 2 modais
      async function recusarPend(l) {
        if (recusando) return;
        recusando = true;
        try {
          if (descartarRpc) { // em uso por visitas: o delete seria barrado pela FK -> quem recusa escolhe o destino das visitas
            const n = await contarUsos(l.id);
            if (n > 0) { descartar({ ...l, usos: n }, () => { crud.recarregar?.(); desenharPend(); }, { permitirEsconder: false, acao: 'Recusar' }); return; }
          }
          abrirModal({
            titulo: `Recusar ${singular}`,
            corpo: [el('p', { class: 'view__sub', style: 'margin-top:0', text: `Recusar a sugestão "${l.nome}"? Ela será removida.` })],
            acoes: [
              { rotulo: 'Cancelar', classe: 'btn' },
              { rotulo: 'Recusar', classe: 'btn btn--perigo', onClick: async () => {
                const { error } = await supabase.from(tabela).delete().eq('id', l.id);
                if (error) { toast(/foreign key/i.test(error.message || '') ? 'Este item já foi usado em visitas e não pode ser apagado. Use "Fundir" para juntar com o cadastro certo.' : 'Não foi possível recusar: ' + error.message, 'erro'); return false; }
                toast('Sugestão recusada.', 'info'); desenharPend(); return true;
              } },
            ],
          });
        } finally { recusando = false; }
      }
      async function desenharPend() {
        clear(divPend);
        const box = el('div');
        divPend.append(el('p', { class: 'view__sub', text: `${rotuloItem}s sugeridos pela recepção, aguardando aprovação. Ao aprovar, passam a ficar disponíveis no balcão.` }), box);
        box.append(loader());
        const linhas = await listarPend();
        badge.textContent = String(linhas.length);
        clear(box);
        if (!linhas.length) { box.append(el('p', { class: 'view__sub', text: 'Nenhuma sugestão pendente.' })); return; }
        renderTabela(box, {
          colunas: [
            { chave: 'nome', rotulo: `${rotuloItem} sugerido`, truncar: true },
            { chave: 'criado_nome', rotulo: 'Sugerido por', render: (l) => formatarNome(l.criado_nome || '') || '—' },
            { chave: 'created_at', rotulo: 'Quando', render: (l) => fmtDataHora(l.created_at) },
            { chave: '_acoes', rotulo: '', ordenavel: false, render: (l) => el('div', { style: 'display:flex;gap:6px;justify-content:flex-end' }, [
              el('button', { class: 'btn btn--primario', title: 'Aprovar', 'aria-label': 'Aprovar', onClick: async () => {
                const existentes = await buscarTodos(() => supabase.from(tabela).select('id, nome').neq('id', l.id)); // todos menos a propria pendencia (avisa duplicata ativa/inativa/pendente)
                abrirAprovacao({
                  titulo: `Aprovar ${singular}`, valorInicial: l.nome, existentes, getNome: (x) => x.nome, rotuloConfirmar: 'Aprovar',
                  aoConfirmar: async (nomeFinal) => {
                    const nome = formatarTitulo(nomeFinal);
                    const { error } = await supabase.from(tabela).update({ nome, status: 'ATIVO' }).eq('id', l.id);
                    if (error) { toast(/duplicate|unique/i.test(error.message || '') ? `Já existe "${nome}" (cadastrado ou aguardando aprovação). Ajuste o nome, ou use "Fundir" / "Recusar".` : 'Erro: ' + error.message, 'erro'); return false; }
                    toast('Aprovado.', 'sucesso'); crud.recarregar?.(); desenharPend(); return true;
                  },
                });
              } }, [el('i', { class: 'ph ph-check' })]),
              el('button', { class: 'btn', title: `Fundir com um ${singular} já cadastrado (já existe)`, 'aria-label': 'Fundir', onClick: () => fundir(l, () => { crud.recarregar?.(); desenharPend(); }) }, [el('i', { class: 'ph ph-git-merge' })]),
              el('button', { class: 'btn', title: 'Recusar (remove a sugestão)', 'aria-label': 'Recusar', onClick: () => recusarPend(l) }, [el('i', { class: 'ph ph-x' })]),
            ]) },
          ],
          linhas, buscarEm: ['nome', 'criado_nome'], porPagina: 10,
        });
      }

      listarPend().then((l) => { badge.textContent = String(l.length); });
      const aoMudar = () => { crud.recarregar?.(); if (pendFeito) desenharPend(); else listarPend().then((l) => { badge.textContent = String(l.length); }); };
      assinarTabela(tabela, aoMudar);
      pollPeriodico(aoMudar);
    },
  };
}

export const paginaVisitaMotivos = fazPaginaLista({
  tabela: 'visita_motivo', rpcUsos: 'visita_motivo_usos', chaveUso: 'motivo_id', fundirRpc: 'fundir_visita_motivo',
  titulo: 'Motivos', singular: 'motivo', rotuloItem: 'Motivo',
  subtitulo: 'Lista controlada (9 categorias) dos motivos de visita. O motivo é uma lista fechada: a recepção escolhe a categoria e descreve o caso no campo "Detalhamento".',
  listarPend: listarMotivosPendentes,
});
export const paginaVisitaEmpresas = fazPaginaLista({
  tabela: 'visita_empresa', rpcUsos: 'visita_empresa_usos', chaveUso: 'empresa_id', fundirRpc: 'fundir_visita_empresa', descartarRpc: 'descartar_visita_empresa',
  titulo: 'Empresas/órgãos representados', singular: 'empresa', rotuloItem: 'Empresa/órgão',
  subtitulo: 'Lista controlada das empresas/órgãos que os visitantes representam. A recepção pode sugerir novos (entram em "Pendentes").',
  listarPend: listarEmpresasPendentes,
});